import { createContext, useContext, useState, type ReactNode } from 'react'
import { Toast } from '@highlight/ui'

const SetSlotContext = createContext<(slot: HTMLDivElement | null) => void>(() => {})

/**
 * The panel's toasts show in `Sidepanel.Toasts`, above the composer, not pinned to the window: the overlay
 * window takes no clicks outside the panel, and the panel moves. They don't swipe away: a downward swipe
 * there aims at the composer.
 */
function SidepanelToastProvider({ children }: { children: ReactNode }) {
  const [slot, setSlot] = useState<HTMLDivElement | null>(null)
  return (
    <SetSlotContext.Provider value={setSlot}>
      <Toast.Provider container={slot} swipeDirection={[]}>
        {children}
      </Toast.Provider>
    </SetSlotContext.Provider>
  )
}

/** Where the panel's toasts appear. */
function SidepanelToasts() {
  return <div ref={useContext(SetSlotContext)} data-slot="sidepanel-toasts" className="pointer-events-none" />
}

export { SidepanelToastProvider, SidepanelToasts }
